<template>
  <div>
    <div class="form-group" v-show="this.data.visibility !== 'hidden'">
      <label v-show="this.showLabel"> {{label}} </label>
      <div class="form-check" v-for="element in options">
        <input :type="type" :value="element.value" class="form-check-input"
               @click="changeValue(element.value)" :checked="selected == element.value" :name="element.tag"
               :placeholder="placeholder">
        <label class="form-check-label" :value="element.value">
          {{element.name}}
        </label>
      </div>
      <small class="form-text text-muted" v-show="data.help_text != ''">{{data.help_text}}</small>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'CheckFieldsMailingBoss',
		props: ['type', 'options', 'label', 'selected', 'data', 'showPlaceholder', 'showLabel'],
		data() {
			return {}
		},
		computed: {
			placeholder() {
				return this.showPlaceholder ? this.label : ''
			},
		},
		methods: {
			changeValue(val) {
				this.selected = val;

				let vm = this;
				let options = this.options;

				this.options = {};
				this.$nextTick(() => {
					vm.options = options;
				})
			}
		}
	}
</script>
